export enum ScheduleStatusEnum {
  home = "home",
  delay = "delay",
  away = "away",
  urgent = "urgent",
}
